__turbopack_context__.v({
  "word": "YYEu3G_word",
  "wrapper": "YYEu3G_wrapper",
});
